@import '../styles/fonts.scss';

.addRoleModal {
  position: fixed;
  top: 83px;
  width: 830px;
}

.roleGroupButtonContainer {
  display: flex;
  justify-content: flex-end;
}

.roleGroupButtonContainer button {
  margin: 0 1rem;
  min-width: fit-content;
}

.rolleListeModal {
  width: 60%;

  .rolleListeContent {
    overflow-y: visible;

    & > p {
      // Overrides for p elements in modal content
      margin: 0;
      max-width: none;
    }
  }
}

.addModalButtons {
  padding-top: 1em;
}

.praksissstedInfoLabel {
  @include barlow(16);
  margin-bottom: 1em;
}
